import { Component } from '@angular/core';
import { ConfigService } from 'ngx-web-api';

@Component({
  selector: 'fts-sms-sign-up-information',
  templateUrl: './sms-sign-up-information.component.html',
  styleUrls: ['./sms-sign-up-information.component.scss'],
})
export class SmsSignUpInformationComponent {
  constructor(public storeConfig: ConfigService) {}
}
